import BusLink from "./core/BusLink";
export const electronBus = (ipc, channel = "graphql") => (request) => ipc.on(channel, (event, message) => request(message, (response) => {
    var _a, _b;
    // When testing this could be undefined (when its mocked)
    if (!((_b = (_a = event.sender).isDestroyed) === null || _b === void 0 ? void 0 : _b.call(_a))) {
        event.sender.send(channel, response);
    }
}));
export const createElectronBusLink = (ipc, channel = "graphql") => new BusLink({
    requestHandler: (request) => {
        ipc.send(channel, request);
    },
    registerResponseHandler: (handler) => {
        ipc.on(channel, (_, response) => handler(response));
    },
});
//# sourceMappingURL=electron.js.map